import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { slideDrawer } from "../../reducers/UIReducer/UIActions";
import { setDatasuiteDrawerContents, setSalesByOperator, setSalesByOperatorLoading, setSalesByCategory,
         setSalesByCategoryLoading, setTopOperator, setTrendingCategory, setTrendingSales, setWidgetCatalog, setGrowthOpportunity,setGrowthOpportunityLoading,
         setLeakage, setLeakageLoading, setTargetsByCategory, setTargetsByCategoryLoading, setCompetitiveInsights, setCompetitiveInsightsLoading,
         setOpportunityByStoreLoading, setOpportunityByStore, setNewLocationsLoading, setNewLocations, setLostLocationsLoading,
         setLostLocations, setSalesVoidOpportunityLoading, setSalesVoidOpportunity, setDatasuiteDetailsDrawerContents, setBiggestGrowthOpportunity,
         setSalesVoidOpportunityDetails, setCompetitiveInsightsDetails, setGrowthOpportunityDetails, setLeakageDetails,
         setLostLocationsDetails, setNewLocationsDetails, setOpportunityByStoreDetails,
         setSalesByCategoryDetails,setSalesByOperatorDetails, setTargetsByCategoryDetails, setItemLevelDescriptionData, setItemLevelDescriptionLoading, setDetailsPageLoading,
         setGrowthOpportunityDetailsLoading, setSalesByOperatorDetailsLoading, setSalesByCategoryDetailsLoading, setLeakageDetailsLoading, setTargetsByCategoryDetailsLoading, setCompetitiveInsightsDetailsLoading,
         setOpportunityByStoreDetailsLoading, setNewLocationsDetailsLoading, setLostLocationsDetailsLoading, setSalesVoidOpportunityDetailsLoading,
         setTopProducts, setTopProductsLoading, setTopProductsDetails,
         setTopCategories, setTopCategoriesLoading, setTopCategoriesDetails, setTopProductsDetailsLoading, setTopCategoriesDetailsLoading,
         setSegmentOverview, setSegmentOverviewLoading, setSegmentOverviewDetails, setSegmentOverviewDetailsLoading, setItemMatchData, setItemMatchLoading,
         } from "../../reducers/DatasuiteReducer/DataSuiteActions";
import { setDataSuiteSelectedWidgets } from "../../reducers/UserReducer/UserActions";
import datasuiteApi from "../../api/datasuiteApi";
import widgetApi from "../../api/widgetApi";
import { toast } from 'react-toastify';
import { stringify } from "csv-stringify";
import fileDownload from "js-file-download";
import moment from "moment";
import { showModal } from "../../reducers/ModalsReducer/ModalsActions";
import ItemMatchModal from "../../sharedComponents/ItemMatch/ItemMatchModal";
import { setHighlightsLoading } from "../../reducers/DatasuiteReducer/DataSuiteActions";
import useManufacturerData from "../../sharedComponents/useManufacturerData/useManufacturerData";
import { useQuery } from "react-query";
import dashboardApi from "../../api/dashboardApi";

const useWidgetControls = () => {
  const dispatch = useDispatch();

  const getWidgetCatalog = () => {
    widgetApi.all().then((res) => {
      dispatch(setWidgetCatalog(res.data));
    }).catch(err => {
      console.log(err);
    });
  }

  const getUserWidgetList = () => {
    widgetApi.get().then((res) => {
      dispatch(setDataSuiteSelectedWidgets(res.data));
    }).catch(err => {
      console.log(err);
    });
  }

  const onClickWidgetDrawerOpen = (title, replaceMode = false, replaceIndex = null) => {
    dispatch(setDatasuiteDrawerContents(title, replaceMode, replaceIndex));
    dispatch(slideDrawer.add());
  }

  const onClickWidgetDetailsDrawerOpen = (title, drawerContents) => {
    dispatch(setDatasuiteDetailsDrawerContents(title, drawerContents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const onClickAddWidget = (widget) => {
    dispatch(slideDrawer.subtract());
    widgetApi.subscribe({widgets: [widget.id]}).then((res) => {
      dispatch(setDataSuiteSelectedWidgets(res.data));
      toast.success("Widget added");
    }).catch(err => {
      console.log(err);
    });
  }

  const onClickReplaceWidget = (widget, position) => {
    dispatch(slideDrawer.subtract());
    widgetApi.replace({widgetId: widget.id, index: position}).then((res) => {
      dispatch(setDataSuiteSelectedWidgets(res.data));
      toast.success("Widget replaced");
    }).catch(err => {
      console.log(err);
    });
  }

  const onClickDeleteWidget = (widget) => {
    widgetApi.unsubscribe({widgets: [widget.id]}).then((res) => {
      dispatch(setDataSuiteSelectedWidgets(res.data));
      toast.success("Widget deleted");
    }).catch(err => {
      console.log(err);
    });
  }

  return {
    getWidgetCatalog,
    getUserWidgetList,
    onClickWidgetDrawerOpen,
    onClickWidgetDetailsDrawerOpen,
    onClickAddWidget,
    onClickReplaceWidget,
    onClickDeleteWidget
  };
}

const useDataSuite = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const fromDate = useSelector(({dates}) => dates.datasuiteFromDate);
  const toDate = useSelector(({dates}) => dates.datasuiteToDate);
  const chainData = useSelector(({user}) => user.chainData);
  const emergingData = useSelector(({user}) => user.emergingData);
  const salesByCategoryData = useSelector(({datasuite}) => datasuite.widgetData.salesByCategoryData);
  const lostLocationsData = useSelector(({datasuite}) => datasuite.widgetData.lostLocationsData);
  const newLocationsData = useSelector(({datasuite}) => datasuite.widgetData.newLocationsData);
  const targetsByCategoryData = useSelector(({datasuite}) => datasuite.widgetData.targetsByCategoryData);
  const leakageData = useSelector(({datasuite}) => datasuite.widgetData.leakageData);
  const growthOpportunityData = useSelector(({datasuite}) => datasuite.widgetData.growthOpportunityData);
  const { manufacturerParams } = useManufacturerData();
  const [returningFromDetails, setReturningFromDetails] = useState(false);
  const defaultSelectedFilters = {
    'startDate': fromDate,
    'endDate': toDate,
    'chainData': chainData,
    'emergingData': emergingData,
    ...manufacturerParams
  };
  const [prechosenFilters, setPrechosenFilters] = useState(defaultSelectedFilters);
  const useGetCategoryFilters = () => useQuery({
    queryKey: ['categoryFilters'],
    queryFn: () => dashboardApi.topCategories.post({
      "chainData": chainData,
      "emergingData": emergingData,
      "startDate": fromDate,
      "endDate": toDate,
      ...manufacturerParams
    }).then((response) => {
      return response.data.map(c => c.category);
    }).catch(err => {
      console.log(err);
    }),
    enabled: chainData || emergingData
  });
  const { refetch: refetchCategoryFilters } = useGetCategoryFilters();

  const getHighlights = (selectedFilters = defaultSelectedFilters) => {
    dispatch(setHighlightsLoading(true));
    const operatorParams = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      ...manufacturerParams
    };
    const salesParams = {
      "startDate": selectedFilters?.startDate ?? fromDate,
      "endDate": selectedFilters?.endDate ?? toDate,
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      ...manufacturerParams
    };
    const categoriesParams = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      ...manufacturerParams
    };
    const growthOpportunityParams = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      ...manufacturerParams
    };

    const topOperator = datasuiteApi.highlights.topOperator.post(operatorParams).then((response) => {
      dispatch(setTopOperator(response.data));
    }).catch(err => {
      console.log(err);
    });
    const trendingSales = datasuiteApi.highlights.trendingSales.post(salesParams).then((response) => {
      dispatch(setTrendingSales(response.data));
    }).catch(err => {
      console.log(err);
    });
    const trendingCategory = datasuiteApi.highlights.trendingCategory.post(categoriesParams).then((response) => {
      dispatch(setTrendingCategory(response.data));
    }).catch(err => {
      console.log(err);
    });
    const growthOpportunity = datasuiteApi.highlights.growthOpportunity.post(growthOpportunityParams).then((response) => {
      dispatch(setBiggestGrowthOpportunity(response.data));
    }).catch(err => {
      console.log(err);
    });
    Promise.allSettled([topOperator, trendingSales, trendingCategory, growthOpportunity]).finally(() => {
      dispatch(setHighlightsLoading(false));
    });
  }

  const getTopOperatorReport = (contents) => {
    if (!salesByCategoryData) {
      getSalesByOperator();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Sales By Operator', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getTopGrowthOpportunityReport = (contents) => {
    if (!growthOpportunityData) {
      getGrowthOpportunity();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Growth Opportunities', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getLostOperatorTrendingReport = (contents) => {
    if (!lostLocationsData) {
      getLostLocations();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Lost Locations', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getOperatorTrendingReport = (contents) => {
    if (!newLocationsData) {
      getNewLocations();
    }
    dispatch(setDatasuiteDetailsDrawerContents('New Locations', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getCategoryTrendingReport = (contents) => {
    if (!targetsByCategoryData) {
      getTargetsByCategory();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Sales By Category', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getComplianceLeakageReport = (contents) => {
    if (!leakageData) {
      getLeakage();
    }
    dispatch(setDatasuiteDetailsDrawerContents('Leakage', contents));
    dispatch(slideDrawer.addDatasuiteDetails());
  }

  const getSalesByOperator = (details = false, byChildLocation = false, selectedFilters = defaultSelectedFilters) => {
    const params = details ? {
      "showChildLocations": byChildLocation,
      ...selectedFilters,
      ...manufacturerParams
    } : {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setSalesByOperatorLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setSalesByOperatorDetailsLoading(true));
    datasuiteApi.widgets.salesByOperator.post(params).then((response) => {
      !details && dispatch(setSalesByOperator(response.data));
      dispatch(setSalesByOperatorDetails(response.data));
      !details && dispatch(setSalesByOperatorLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setSalesByOperatorDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

    const getSalesByOperatorItemLevel = (locationName, category, selectedFilters = defaultSelectedFilters) => {
    const params = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      "startDate": selectedFilters?.startDate,
      "endDate": selectedFilters?.endDate,
      "categories": category,
      "distributors": selectedFilters?.distributors,
      "locations": locationName,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      "filterByChild": true,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSalesByCategory = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = {
      ...selectedFilters,
      ...manufacturerParams
    }
    !details && dispatch(setSalesByCategoryLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setSalesByCategoryDetailsLoading(true));
    datasuiteApi.widgets.salesByCategory.post(params).then((response) => {
      !details && dispatch(setSalesByCategory(response.data));
      dispatch(setSalesByCategoryDetails(response.data));
      !details && dispatch(setSalesByCategoryLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setSalesByCategoryDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSalesByCategoryItemLevel = (category, selectedFilters = defaultSelectedFilters) => {
    const params = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      "startDate": selectedFilters?.startDate,
      "endDate": selectedFilters?.endDate,
      "categories": category,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getGrowthOpportunity = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = details ? {
      "getMatches": true,
      ...selectedFilters,
      ...manufacturerParams
    } : {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setGrowthOpportunityLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setGrowthOpportunityDetailsLoading(true));
    datasuiteApi.widgets.growthOpportunity.post(params).then((response) => {
      !details && dispatch(setGrowthOpportunity(response.data));
      dispatch(setGrowthOpportunityDetails(response.data));
      !details && dispatch(setGrowthOpportunityLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setGrowthOpportunityDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getGrowthOpportunityItemLevel = (operatorName, category, selectedFilters = defaultSelectedFilters) => {
    const params = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      "startDate": selectedFilters?.startDate,
      "endDate": selectedFilters?.endDate,
      "categories": category,
      "distributors": selectedFilters?.distributors,
      "locations": operatorName,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getLeakageItemLevel = (operatorName, category, selectedFilters = defaultSelectedFilters) => {
    const params = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      "startDate": selectedFilters?.startDate,
      "endDate": selectedFilters?.endDate,
      "categories": category,
      "distributors": selectedFilters?.distributors,
      "locations": operatorName,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getLeakage = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setLeakageLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setLeakageDetailsLoading(true));
    datasuiteApi.widgets.leakage.post(params).then((response) => {
      !details && dispatch(setLeakage(response.data));
      dispatch(setLeakageDetails(response.data));
      !details && dispatch(setLeakageLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setLeakageDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getTargetsByCategory = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setTargetsByCategoryLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setTargetsByCategoryDetailsLoading(true));
    datasuiteApi.widgets.targetsByCategory.post(params).then((response) => {
      !details && dispatch(setTargetsByCategory(response.data));
      dispatch(setTargetsByCategoryDetails(response.data));
      !details && dispatch(setTargetsByCategoryLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setTargetsByCategoryDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getTargetsByCategoryItemLevel = (category, selectedFilters = defaultSelectedFilters) => {
    const params = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      "startDate": selectedFilters?.startDate,
      "endDate": selectedFilters?.endDate,
      "categories": category,
      "distributors": selectedFilters?.distributors,
      "locations": selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getCompetitiveInsights = async (details = false, selectedFilters = defaultSelectedFilters) => {
    !details && dispatch(setCompetitiveInsightsLoading(true));
    details && dispatch(setCompetitiveInsightsDetailsLoading(true));
    let params = {};
    if(selectedFilters?.categories?.length > 0) {
      params = {
        ...selectedFilters,
        ...manufacturerParams
      };
    } else {
      const categoryFilters = await refetchCategoryFilters().then((res) => {
        return res.data;
      }).catch(err => { return []; });
      params = {
        ...selectedFilters,
        categories: categoryFilters,
        ...manufacturerParams
      };
    }
    datasuiteApi.widgets.competitiveInsights.post(params).then((response) => {
      !details && dispatch(setCompetitiveInsights(response.data));
      dispatch(setCompetitiveInsightsDetails(response.data));
      !details && dispatch(setCompetitiveInsightsLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setCompetitiveInsightsDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getOpportunityByStore = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setOpportunityByStoreLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setOpportunityByStoreDetailsLoading(true));
    datasuiteApi.widgets.opportunityByStore.post(params).then((response) => {
      !details && dispatch(setOpportunityByStore(response.data));
      dispatch(setOpportunityByStoreDetails(response.data));
      !details && dispatch(setOpportunityByStoreLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setOpportunityByStoreDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getNewLocations = (details = false, filterByChild = false, selectedFilters = defaultSelectedFilters) => {
    const params = details ? {
      "filterByChild": filterByChild,
      ...selectedFilters,
      ...manufacturerParams
    } : {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setNewLocationsLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setNewLocationsDetailsLoading(true));
    datasuiteApi.widgets.newLocations.post(params).then((response) => {
      !details && dispatch(setNewLocations(response.data));
      dispatch(setNewLocationsDetails(response.data));
      !details && dispatch(setNewLocationsLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setNewLocationsDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getNewLocationsItemLevel = (locationName, selectedFilters = defaultSelectedFilters) => {
    const params = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      "startDate": selectedFilters?.startDate,
      "endDate": selectedFilters?.endDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": locationName,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      "filterByChild": true,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getLostLocations = (details = false, filterByChild = false, selectedFilters = defaultSelectedFilters) => {
    const params = details ? {
      "filterByChild": filterByChild,
      ...selectedFilters,
      ...manufacturerParams
    } : {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setLostLocationsLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setLostLocationsDetailsLoading(true));
    datasuiteApi.widgets.lostLocations.post(params).then((response) => {
      !details && dispatch(setLostLocations(response.data));
      dispatch(setLostLocationsDetails(response.data));
      !details && dispatch(setLostLocationsLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setLostLocationsDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSalesVoidOpportunity = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setSalesVoidOpportunityLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setSalesVoidOpportunityDetailsLoading(true));
    datasuiteApi.widgets.salesVoid.post(params).then((response) => {
      !details && dispatch(setSalesVoidOpportunity(response.data));
      dispatch(setSalesVoidOpportunityDetails(response.data));
      !details && dispatch(setSalesVoidOpportunityLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setSalesVoidOpportunityDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSalesVoidItemLevel = (locationName, selectedFilters = defaultSelectedFilters) => {
    const params = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      "startDate": selectedFilters?.startDate,
      "endDate": selectedFilters?.endDate,
      "categories": selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": locationName,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemLevelDescriptionLoading(true));
    dispatch(setItemLevelDescriptionData([]));
    datasuiteApi.widgets.itemLevelDescriptions.post(params).then((response) => {
      dispatch(setItemLevelDescriptionData(response.data));
      dispatch(setItemLevelDescriptionLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getTopProducts = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setTopProductsLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setTopProductsDetailsLoading(true));
    datasuiteApi.widgets.topProducts.post(params).then(response => {
      !details && dispatch(setTopProducts(response.data));
      dispatch(setTopProductsDetails(response.data));
      !details && dispatch(setTopProductsLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setTopProductsDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getTopCategories = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setTopCategoriesLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setTopCategoriesDetailsLoading(true));
    datasuiteApi.widgets.topCategories.post(params).then(response => {
      !details && dispatch(setTopCategories(response.data));
      dispatch(setTopCategoriesDetails(response.data));
      !details && dispatch(setTopCategoriesLoading(false));
      details && dispatch(setDetailsPageLoading(false));
      details && dispatch(setTopCategoriesDetailsLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const getSegmentOverview = (details = false, selectedFilters = defaultSelectedFilters) => {
    const params = {
      ...selectedFilters,
      ...manufacturerParams
    };
    !details && dispatch(setSegmentOverviewLoading(true));
    details && dispatch(setDetailsPageLoading(true));
    details && dispatch(setSegmentOverviewDetailsLoading(true));
    datasuiteApi.widgets.segmentOverview.post(params).then((response) => {
        !details && dispatch(setSegmentOverview(response.data));
        dispatch(setSegmentOverviewDetails(response.data));
        !details && dispatch(setSegmentOverviewLoading(false));
        details && dispatch(setDetailsPageLoading(false));
        details && dispatch(setSegmentOverviewDetailsLoading(false));
      })
      .catch(err => {
        console.log(err);
      });
  };

  const filterTargetsByCategoryTable = () => {
    // Declare variables
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("targetsByCategorySearchInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("targetsByCategoryTable");
    tr = table.getElementsByClassName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByClassName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  const filterTargetsByCategoryDetailsTable = () => {
    // Declare variables
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("targetsByCategoryDetailsSearchInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("targetsByCategoryDetailsTable");
    tr = table.getElementsByClassName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByClassName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  const onClickViewDetails = (widgetName, selectedFilters = defaultSelectedFilters) => {
    if (pathname?.toLowerCase().includes('salesstream')) {
      navigate({pathname: '/salesstream/details', search: "?" + widgetName}, {state: {selectedFilters: selectedFilters}});
    } else {
      navigate({pathname: '/growthopportunities/details', search: "?" + widgetName}, {state: {selectedFilters: selectedFilters}});
    }
  }

  const onClickViewItemMatches = (location, category) => {
    dispatch(showModal(ItemMatchModal, {category: category, location: location}));
  }

  const getItemMatches = (locationName, category, selectedFilters = defaultSelectedFilters) => {
    const params = {
      "chainData": selectedFilters?.chainData,
      "emergingData": selectedFilters?.emergingData,
      "startDate": selectedFilters?.startDate,
      "endDate": selectedFilters?.endDate,
      "categories": category ?? selectedFilters?.categories,
      "distributors": selectedFilters?.distributors,
      "locations": locationName ?? selectedFilters?.locations,
      "segments": selectedFilters?.segments,
      "states": selectedFilters?.states,
      "searchInclude": selectedFilters?.includedSearch,
      "searchExclude": selectedFilters?.excludedSearch,
      "children": selectedFilters?.children,
      ...manufacturerParams
    }
    dispatch(setItemMatchLoading(true));
    datasuiteApi.itemMatch.post(params).then((response) => {
      dispatch(setItemMatchData(response.data));
      dispatch(setItemMatchLoading(false));
    }).catch(err => {
      console.log(err);
    });
  }

  const onClickItemMatchesExport = (itemMatches, mfrName, category) => {
    if (itemMatches) {
      let csvData = [];
      // CSV column headers
      csvData.push([
        'MIN',
        'Description',
        'Category',
        'Pack Size',
        'Cases'
      ]);

      itemMatches.forEach(itemMatch => {
        // CSV data rows
        csvData.push([
          itemMatch.match_min,
          itemMatch.match_description,
          category,
          itemMatch.match_pack,
          itemMatch.total_cases
        ]);
      });

      // Start the Download
      stringify(csvData, (err, output) => {
        if (err) {
          console.error('Error generating CSV:', err);
          return;
        }
        fileDownload(output, `MatchedItems_${mfrName.replaceAll(' ', '')}_${category.replaceAll(' ', '')}_${moment().format('DDMMYYYY_hmmss').toString()}.csv`);
      });
    }
  }

  const getDetailsData = (selectedFilters = defaultSelectedFilters, widgetName = '') => {
    switch (widgetName) {
      case ("Competitive Insights") : {
        getCompetitiveInsights(true, selectedFilters);
        break;
      }
      case ("Growth Opportunities") : {
        getGrowthOpportunity(true, selectedFilters);
        break;
      }
      case ("Leakage") : {
        getLeakage(true, selectedFilters);
        break;
      }
      case ("Lost Locations") : {
        getLostLocations(true, true, selectedFilters);
        break;
      }
      case ("New Locations") : {
        getNewLocations(true, true, selectedFilters);
        break;
      }
      case ("Opportunities By Store") : {
        getOpportunityByStore(true, selectedFilters);
        break;
      }
      case ("Sales By Category") : {
        getSalesByCategory(true, selectedFilters);
        break;
      }
      case ("Sales By Operator") : {
        getSalesByOperator(true, true, selectedFilters);
        break;
      }
      case ("Sales Void Opportunities") : {
        getSalesVoidOpportunity(true, selectedFilters);
        break;
      }
      case ("Targets By Category") : {
        getTargetsByCategory(true, selectedFilters);
        break;
      }
      case ("Top Products") : {
        getTopProducts(true, selectedFilters);
        break;
      }
      case ("Top Categories") : {
        getTopCategories(true, selectedFilters);
        break;
      }
      case ("Segment Overview"): {
        getSegmentOverview(true, selectedFilters);
        break;
      }
      default : {
        // Do nothing
      }
    }
  };

  const getAllData = (selectedFilters = defaultSelectedFilters) => {
    getHighlights(selectedFilters);
    getSalesByOperator(false, false, selectedFilters);
    getSalesByCategory(false, selectedFilters);
    getGrowthOpportunity(false, selectedFilters);
    getLeakage(false, selectedFilters);
    getTargetsByCategory(false, selectedFilters);
    getCompetitiveInsights(false, selectedFilters);
    getSegmentOverview(false, selectedFilters);
    getSalesVoidOpportunity(false, selectedFilters);
    getNewLocations(false, false, selectedFilters);
    getLostLocations(false, false, selectedFilters);
    getTopCategories(false, selectedFilters);
    getTopProducts(false, selectedFilters);
    getOpportunityByStore(false, selectedFilters);
  }

  const updateWidgetContent = (widgetName, selectedFilters = defaultSelectedFilters) => {
    switch (widgetName) {
      case ("Competitive Insights") : {
        getCompetitiveInsights(true, selectedFilters);
        break;
      }
      case ("Growth Opportunities") : {
        getGrowthOpportunity(true, selectedFilters);
        break;
      }
      case ("Leakage") : {
        getLeakage(true, selectedFilters);
        break;
      }
      case ("Lost Locations") : {
        getLostLocations(true, true, selectedFilters);
        break;
      }
      case ("New Locations") : {
        getNewLocations(true, true, selectedFilters);
        break;
      }
      case ("Opportunities By Store") : {
        getOpportunityByStore(true, selectedFilters);
        break;
      }
      case ("Sales By Category") : {
        getSalesByCategory(true, selectedFilters);
        break;
      }
      case ("Sales By Operator") : {
        if (returningFromDetails) {
          getSalesByOperator(true, false, selectedFilters);
        } else {
          getSalesByOperator(true, true, selectedFilters);
        }
        break;
      }
      case ("Sales Void Opportunities") : {
        getSalesVoidOpportunity(true, selectedFilters);
        break;
      }
      case ("Targets By Category") : {
        getTargetsByCategory(true, selectedFilters);
        break;
      }
      case ("Top Products") : {
        getTopProducts(true, selectedFilters);
        break;
      }
      case ("Top Categories") : {
        getTopCategories(true, selectedFilters);
        break;
      }
      case ("Segment Overview"): {
        getSegmentOverview(true, selectedFilters);
        break;
      }
      default : {
        // Do nothing
      }
    }
    setReturningFromDetails(false);
  };

  return {
    fromDate,
    toDate,
    prechosenFilters, setPrechosenFilters,
    defaultSelectedFilters,
    setReturningFromDetails,
    getHighlights,
    getTopOperatorReport,
    getTopGrowthOpportunityReport,
    getOperatorTrendingReport,
    getLostOperatorTrendingReport,
    getCategoryTrendingReport,
    getComplianceLeakageReport,
    getSalesByOperator,
    getSalesByCategory,
    getGrowthOpportunity,
    getLeakage,
    getTargetsByCategory,
    getCompetitiveInsights,
    filterTargetsByCategoryTable,
    filterTargetsByCategoryDetailsTable,
    getOpportunityByStore,
    getNewLocations,
    getLostLocations,
    getSalesVoidOpportunity,
    onClickViewDetails,
    getNewLocationsItemLevel,
    getSalesByOperatorItemLevel,
    getSalesByCategoryItemLevel,
    getGrowthOpportunityItemLevel,
    getLeakageItemLevel,
    getSalesVoidItemLevel,
    getTargetsByCategoryItemLevel,
    getItemMatches,
    onClickViewItemMatches,
    onClickItemMatchesExport,
    getTopProducts,
    getTopCategories,
    getSegmentOverview,
    getAllData,
    getDetailsData,
    updateWidgetContent
  };
}

// eslint-disable-next-line
export default { useWidgetControls, useDataSuite };
